import { TileLayer, Util } from "leaflet";
import { pointerEvents } from "../Support";
import {
  setEsriAttribution,
  removeEsriAttribution,
  _getAttributionData,
  _updateMapAttribution,
} from "../Util";

var tileProtocol = window.location.protocol !== "https:" ? "http:" : "https:";

export var BasemapLayer = TileLayer.extend({
  statics: {
    TILES: {
      "geoscene-blue": {
        urlTemplate:
          tileProtocol +
          "//map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetPurplishBlue/MapServer/tile/{z}/{y}/{x}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "蓝黑色中文不含兴趣点版中国基础地图",
          attributionUrl: "",
        },
      },

      "geoscene-community": {
        urlTemplate:
          tileProtocol +
          "//map.geoq.cn/arcgis/rest/services/ChinaOnlineCommunity/MapServer/tile/{z}/{y}/{x}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "彩色版基础底图",
          attributionUrl: "",
        },
      },

      "geoscene-gray": {
        urlTemplate:
          tileProtocol +
          "//map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetGray/MapServer/tile/{z}/{y}/{x}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "灰色不含兴趣点版中国基础地图",
          attributionUrl: "",
        },
      },

      "geoscene-warm": {
        urlTemplate:
          tileProtocol +
          "//map.geoq.cn/arcgis/rest/services/ChinaOnlineStreetWarm/MapServer/tile/{z}/{y}/{x}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "暖色不含兴趣点版中国基础地图",
          attributionUrl: "",
        },
      },

      // 天地图矢量标注
      "tianditu-vector-annotion": {
        urlTemplate:
          "//t{s}.tianditu.gov.cn/DataServer?T=cva_w&X={x}&Y={y}&L={z}&tk={key}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "天地图-矢量地图（球面墨卡托投影）",
          attributionUrl: "",
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
          key: "4267820f43926eaf808d61dc07269beb",
        },
      },
      // 天地图矢量标注
      "tianditu-vector": {
        urlTemplate:
          "//t{s}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk={key}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "天地图-矢量地图（球面墨卡托投影）",
          attributionUrl: "",
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
          key: "4267820f43926eaf808d61dc07269beb",
        },
      },

      // 天地图影像标注
      "tianditu-image-annotion": {
        urlTemplate:
          "//t{s}.tianditu.gov.cn/DataServer?T=cia_w&X={x}&Y={y}&L={z}&tk={key}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "天地图-影像地图（球面墨卡托投影）",
          attributionUrl: "",
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
          key: "4267820f43926eaf808d61dc07269beb",
        },
      },
      // 天地图影像
      "tianditu-image": {
        urlTemplate:
          "//t{s}.tianditu.gov.cn/DataServer?T=img_w&X={x}&Y={y}&L={z}&tk={key}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "天地图-影像地图（球面墨卡托投影）",
          attributionUrl: "",
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
          key: "4267820f43926eaf808d61dc07269beb",
        },
      },

      // 天地图地形标注
      "tianditu-topography-annotion": {
        urlTemplate:
          "//t{s}.tianditu.gov.cn/DataServer?T=cta_w&X={x}&Y={y}&L={z}&tk={key}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "天地图-地形（球面墨卡托投影）",
          attributionUrl: "",
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
          key: "4267820f43926eaf808d61dc07269beb",
        },
      },
      // 天地图地形
      "tianditu-topography": {
        urlTemplate:
          "//t{s}.tianditu.gov.cn/DataServer?T=ter_w&X={x}&Y={y}&L={z}&tk={key}",
        options: {
          minZoom: 1,
          maxZoom: 19,
          attribution: "天地图-地形（球面墨卡托投影）",
          attributionUrl: "",
          subdomains: ["0", "1", "2", "3", "4", "5", "6", "7"],
          key: "4267820f43926eaf808d61dc07269beb",
        },
      },
    },
  },

  initialize: function (key, options) {
    var config;

    // set the config variable with the appropriate config object
    if (typeof key === "object" && key.urlTemplate && key.options) {
      config = key;
    } else if (typeof key === "string" && BasemapLayer.TILES[key]) {
      config = BasemapLayer.TILES[key];
    } else {
      throw new Error(
        'L.geoscene.BasemapLayer: Invalid parameter. Use one of "geoscene-blue", "Topographic", "geoscene-community", "geoscene-gray", "geoscene-warm", "tianditu-vector-annotion", "tianditu-vector", "tianditu-image-annotion", "tianditu-image", "tianditu-topography-annotion", "tianditu-topography"'
      );
    }

    // merge passed options into the config options
    var tileOptions = Util.extend(config.options, options);

    Util.setOptions(this, tileOptions);

    // Deprecation notice:
    if (!this.options.ignoreDeprecationWarning) {
      console.warn(
        "WARNING: L.geoscene.BasemapLayer uses data services that are in mature support and are not being updated. Please use L.geoscene.Vector.vectorBasemapLayer instead. "
      );
    }

    if (this.options.token && config.urlTemplate.indexOf("token=") === -1) {
      config.urlTemplate += "?token=" + this.options.token;
    }
    if (this.options.proxy) {
      config.urlTemplate = this.options.proxy + "?" + config.urlTemplate;
    }

    // call the initialize method on L.TileLayer to set everything up
    TileLayer.prototype.initialize.call(this, config.urlTemplate, tileOptions);
  },

  onAdd: function (map) {
    // include 'Powered by GeoScene' in map attribution
    setEsriAttribution(map);

    if (this.options.pane === "esri-labels") {
      this._initPane();
    }
    // some basemaps can supply dynamic attribution
    if (this.options.attributionUrl) {
      _getAttributionData(
        (this.options.proxy ? this.options.proxy + "?" : "") +
          this.options.attributionUrl,
        map
      );
    }

    map.on("moveend", _updateMapAttribution);

    TileLayer.prototype.onAdd.call(this, map);
  },

  onRemove: function (map) {
    removeEsriAttribution(map);

    map.off("moveend", _updateMapAttribution);

    TileLayer.prototype.onRemove.call(this, map);
  },

  _initPane: function () {
    if (!this._map.getPane(this.options.pane)) {
      var pane = this._map.createPane(this.options.pane);
      pane.style.pointerEvents = "none";
      pane.style.zIndex = 500;
    }
  },

  getAttribution: function () {
    if (this.options.attribution) {
      var attribution =
        '<span class="esri-dynamic-attribution">' +
        this.options.attribution +
        "</span>";
    }
    return attribution;
  },
});

export function basemapLayer(key, options) {
  return new BasemapLayer(key, options);
}

export default basemapLayer;
